import React from 'react';
import { withSnackbar } from 'notistack';

import { ScreenTitle } from '../../../../components';
import './style.scss';
import {
  Strings,
  TEST_INSTRUCTIONS,
} from '../../../../shared/constants/Constants';
import { ROUTE_CONSTANTS } from '../../../../shared/constants/Route';
import LoadingModal from '../../../../components/atoms/LoadingModal';

const InfoScreen = ({
  userId,
  sessionToken,
  gotoSimulatedTest,
  enqueueSnackbar,
  history,
  loading,
  fetchChallengeList,
  fetchChallengeAcceptList,
}) => {
  const util = (startIndex, endIndex) => {
    return TEST_INSTRUCTIONS.slice(startIndex, endIndex);
  };

  const startTest = () => {
    const questionBody = {
      userId,
      sessionToken,
    };
    fetchChallengeList(questionBody, (message, type) => {
      if (type !== 'success') {
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      }
    });
    fetchChallengeAcceptList(questionBody, (message, type) => {
      if (type !== 'success') {
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      }
    });
    gotoSimulatedTest(questionBody, (message, type) => {
      if (type === 'success') {
        history.push(ROUTE_CONSTANTS.SIMULATDED_TESTS_QUESTIONS);
      } else {
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      }
    });
  };

  return (
    <>
      <ScreenTitle title={Strings.simulatedTest}/>
      {loading ? (
        <LoadingModal isVisible={loading}/>
      ) : (
        <>
          <div className='test-info-container'>
            <ul>
              {util(0, 3).map((instruction, index) => (
                <li key={index}>{instruction}</li>
              ))}
              <ul style={{ listStyleType: 'decimal' }}>
                {util(3, 5).map((instruction, index) => (
                  <li key={index}>{instruction}</li>
                ))}
              </ul>
              {util(5, 12).map((instruction, index) => (
                <li key={index}>{instruction}</li>
              ))}
            </ul>
            <p className='good-luck'>{TEST_INSTRUCTIONS[12]}</p>
            <div className='info-footer'>
              <p>{TEST_INSTRUCTIONS[13]}</p>
              <a
                // href="https://www.diehl1.com"
                target='_blank'
                rel='noopener noreferrer'
              >
                {TEST_INSTRUCTIONS[14]}
              </a>
            </div>
          </div>
          <button
            className='start-cards-btn mt-2 ml-0 start-test'
            onClick={startTest}
          >
            {Strings.startSimulatedTest}
          </button>
        </>
      )}
    </>
  );
};

export default withSnackbar(InfoScreen);
